// src/pages/DonMerci.jsx   → route : /don/merci
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FaHeart, FaReceipt } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getDonSession, euros } from "../services/DonService";

export default function DonMerci() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [don, setDon] = useState(null);
  const [erreur, setErreur] = useState("");

  useEffect(() => {
    if (!sessionId) return setErreur("Lien invalide.");
    let essais = 0;
    let stop = false;

    // On réessaie quelques fois si le paiement n'est pas encore confirmé
    const charger = async () => {
      try {
        const d = await getDonSession(sessionId);
        if (stop) return;
        setDon(d);
        if (d.statut !== "paye" && essais++ < 5) setTimeout(charger, 2000);
      } catch (e) {
        if (!stop) setErreur(e.message);
      }
    };
    charger();
    return () => { stop = true; };
  }, [sessionId]);

  return (
    <div className="bg-black min-h-screen text-white flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="max-w-lg w-full text-center bg-gradient-to-br from-[#1a0b33] to-[#0d0d0d] border border-violet-800/60 rounded-3xl p-8 md:p-10">
          {erreur ? (
            <>
              <p className="text-red-400 mb-6">{erreur}</p>
              <Link to="/" className="text-violet-400 font-bold">Retour à l'accueil</Link>
            </>
          ) : !don ? (
            <div className="animate-pulse space-y-4">
              <div className="w-20 h-20 rounded-full bg-violet-900/50 mx-auto" />
              <div className="h-6 bg-violet-900/40 rounded w-2/3 mx-auto" />
              <div className="h-4 bg-violet-900/30 rounded w-1/2 mx-auto" />
            </div>
          ) : (
            <>
              <div className="w-20 h-20 rounded-full bg-violet-600 mx-auto flex items-center justify-center text-3xl animate-bounce">
                <FaHeart />
              </div>
              <h1 className="font-archivo text-3xl md:text-4xl font-extrabold mt-6">
                Générosité validée !
              </h1>
              <p className="text-gray-300 mt-3">
                Merci <strong>{don.nom?.split(" ")[0]}</strong> 💜 Votre don de{" "}
                <strong className="text-violet-400">{euros(don.montant)}</strong> aide Thrundrz à rester en ligne.
              </p>

              <div className="bg-black/40 rounded-2xl p-4 mt-6 text-sm text-left space-y-2">
                <div className="flex justify-between"><span className="text-gray-400">Référence</span><span className="font-bold">{don.ref}</span></div>
                <div className="flex justify-between"><span className="text-gray-400">Montant</span><span className="font-bold">{euros(don.montant)}</span></div>
                <div className="flex justify-between"><span className="text-gray-400">Reversé à l'asso</span><span className="font-bold text-violet-400">{euros(don.net)}</span></div>
                <div className="flex justify-between"><span className="text-gray-400">Statut</span>
                  <span className={`font-bold ${don.statut === "paye" ? "text-green-400" : "text-yellow-400"}`}>
                    {don.statut === "paye" ? "Confirmé" : "Confirmation en cours…"}
                  </span>
                </div>
              </div>

              <p className="text-gray-400 text-sm mt-5">📩 Un email de confirmation vous a été envoyé.</p>

              <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
                <Link to="/" className="px-6 py-3 rounded-full bg-violet-600 hover:bg-violet-700 font-bold transition">
                  Découvrir les événements
                </Link>
                {don.recu_url && (
                  <a href={don.recu_url} target="_blank" rel="noreferrer"
                     className="px-6 py-3 rounded-full border-2 border-violet-600 font-bold flex items-center justify-center gap-2 hover:bg-violet-900/40 transition">
                    <FaReceipt /> Reçu
                  </a>
                )}
              </div>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}